/**
 * Node Modules
 */
import React, { useState } from 'react'
import { Link } from 'gatsby'

/**
 * Application Modules
 */
import './style.css'

/**
 * Component
 */
export default function NavigationOverlay() {
  const [isOpen, setIsOpen] = useState(false)

  function handleSetIsOpen(e) {
    setIsOpen(!isOpen)
  }

  function handleClose() {
    setTimeout(() => {
      setIsOpen(false)
    }, 450)
  }

  return (
    <div className="column-start-6 column-start-12--t column-end-12--t column-end-6 navigation-overlay__wrapper">
      <Hambuger isOpen={isOpen} handleSetIsOpen={handleSetIsOpen} />
      <Modal isOpen={isOpen} handleClose={handleClose} />
    </div>
  )
}

export function Hambuger({ isOpen, handleSetIsOpen }) {
  return (
    <button
      name="Menu"
      aria-label="Menu"
      className={`reset navigation-overlay__hamburger column-start-6 column-start-12--t column-end-12--t ${
        isOpen ? 'open' : ''
      }`}
      onClick={handleSetIsOpen}
    >
      <svg className="navigation-overlay__hamburger-open" viewBox="0 0 20 20">
        <g
          fill="none"
          stroke="var(--color)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M1.579 18.421L19.035.965M1.579 1.579l17.456 17.456" />
        </g>
      </svg>
      <svg className="navigation-overlay__hamburger-closed" viewBox="0 0 28 16">
        <g
          fill="none"
          stroke="var(--color)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M.995 1.5h25.921M.995 14.5h25.921" />
        </g>
      </svg>
    </button>
  )
}

export function Modal({ isOpen, handleClose }) {
  return (
    <div className={`navigation-overlay__modal ${isOpen ? 'open' : ''}`}>
      <div className="grid">
        <ul className="navigation-overlay__nav-list column-start-1 column-end-6 column-end-12--t">
          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link"
              to="/about"
            >
              About Us
            </Link>
          </li>
          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link  navigation-overlay__nav-link--sub"
              to="/life-at-kinzoo"
            >
              Life at Kinzoo
            </Link>
          </li>
          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link navigation-overlay__nav-link--sub"
              to="/our-values"
            >
              Our Values
            </Link>
          </li>
          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link navigation-overlay__nav-link--sub"
              to="/our-story"
            >
              Our Story
            </Link>
          </li>

          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link  navigation-overlay__nav-link--sub"
              to="/community-guidelines"
            >
              Community Guidelines
            </Link>
          </li>

          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link"
              to="/get-involved"
            >
              Get Involved
            </Link>
          </li>

          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link"
              to="/press-release"
            >
              Press
            </Link>
          </li>
          
          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link"
              to="/blog/"     
            >
              Blog
            </Link>
          </li>

          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link"
              to="/help-center"
            >
              Help
            </Link>
          </li>


          <li className="navigation-overlay__nav-item">
            <Link
              onClick={handleClose}
              activeClassName="active"
              className="navigation-overlay__nav-link"
              to="/download"
            >
              Download
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}
